module.exports = __webpack_public_path__ + "img/2306049-48-7.dd9aa28a.png";